import { IconButton, Menu, MenuItem, MenuRoot } from '@cimpress-ui/react';
import { IconMenuMoreVertical } from '@cimpress-ui/react/icons';

type OverviewDropdownProps = {
  showDecisionLinks?: boolean;
  decisionLink?: string;
};

export const OverviewDropdown = ({ showDecisionLinks = true, decisionLink }: OverviewDropdownProps) => {
  return (
    <MenuRoot data-cim-style-root>
      <IconButton
        data-testid="overview-dropdown"
        data-cim-style-root
        icon={<IconMenuMoreVertical />}
        aria-label="Additional links"
        marginRight={16}
      />
      <Menu>
        {showDecisionLinks && decisionLink && (
          <MenuItem href={decisionLink} target="_blank" data-testid="current-decision-link">
            View decision JSON
          </MenuItem>
        )}
        <MenuItem
          href="https://cimpress-support.atlassian.net/wiki/spaces/CI/pages/14935785539"
          target="_blank"
          data-testid="documentation-link"
        >
          View routing documentation
        </MenuItem>
      </Menu>
    </MenuRoot>
  );
};
